import { Link } from "react-router-dom";
import { shopApi } from "@/lib/shopApi";
import { useBlobImage } from "@/lib/useBlobImage";

export const AtlMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="10" fill="#89CFF0" />
    <path d="M11 29 L20 10 L29 29" fill="none" stroke="#0F172A" strokeWidth="3.2" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M14.8 22.5 H25.2" stroke="#0F172A" strokeWidth="3.2" strokeLinecap="round" />
  </svg>
);

export function AtlLogo({ to = "/", light = false }) {
  return (
    <Link to={to} className="flex items-center gap-2.5" data-testid="store-logo-link">
      <AtlMark />
      <div className="leading-none">
        <div className={`font-head text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>ATL</div>
        <div className={`mt-0.5 text-[10px] font-semibold uppercase tracking-[0.22em] ${light ? "text-sky-100" : "text-sky-700"}`}>Wellness</div>
      </div>
    </Link>
  );
}

export function ProductTile({ product, className = "", imageId }) {
  const id = imageId || product.image_ids?.[0];
  const blob = useBlobImage(shopApi, id ? `/shop/product-images/${id}` : null);
  const src = blob || (!id && product.image_url);
  if (src)
    return <img src={src} alt={product.name} className={`h-full w-full object-cover ${className}`} data-testid="product-image" />;
  return (
    <div className={`relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-sky-50 via-white to-sky-100 ${className}`}>
      <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-sky-100/70" />
      <svg viewBox="0 0 48 64" className="relative h-16 w-12 text-sky-400" aria-hidden="true">
        <rect x="16" y="2" width="16" height="9" rx="2" fill="currentColor" opacity=".55" />
        <rect x="10" y="12" width="28" height="48" rx="6" fill="white" stroke="currentColor" strokeWidth="2" />
        <rect x="14" y="30" width="20" height="14" rx="2" fill="#E0F2FE" />
      </svg>
      {product.size && (
        <span className="relative mt-3 rounded-md border border-sky-200 bg-white px-2 py-0.5 font-mono text-xs font-semibold text-sky-800">{product.size}</span>
      )}
    </div>
  );
}
